<template>
	<div class="index_main">
		<el-carousel :height="height+'px'" indicator-position="none">
			<el-carousel-item v-for="(item,index) in banner" :key="index">
				<img :src="item.image" ref="imgSize" alt="">
			</el-carousel-item>
		</el-carousel>
		<div class="main">
			<div class="infoNum">
				<div>
					<span>{{info.jingyan}}</span>
					教研经验（年）
				</div>
				<div>
					<span>{{info.teacher}}</span>
					优秀教师
				</div>
				<div>
					<span>{{info.student}}</span>
					累计服务学员
				</div>
			</div>
			<div class="main_title">
				<div class="title">关于我们</div>
				<el-image src="./static/images/fgx.png" fit="contain">
				</el-image>
				<div class="subtitle">秉承“用心文化丶追求卓越”，为经营理念，注重打造以“学习型丶服务型丶创新型”为核心企业文化</div>
			</div>
			<div class="column_info" v-html="about">
				<!-- <div class="left">
					<div class="title">
						学易点教育科技有限公司
						<span>Xueyidian Education Technology Co., Ltd</span>
					</div>
					<div class="icon1"></div>
					<div class="text">
						上海助佳实业有限公司成立于2013年，以房地产、运营外卖平台为一体的实业有限公司。响应一带一路的号召，踏出国门，挺近东南亚。
					</div>
					<div class="link">
						查看更多
					</div>
				</div>
				<div class="right">
					<el-image src="./static/images/gs.png" fit="contain"> </el-image>
					<div class="bg"></div>
				</div> -->
			</div>
			<div class="main_title">
				<div class="title">名师专区</div>
				<el-image src="./static/images/fgx.png" fit="contain">
				</el-image>
				<div class="subtitle">全国优秀的辅导员，针对每一位学员制定复习备考计划案.</div>
			</div>
			<div class="teacher">
				<div class="li" v-for="(item,index) in teacher" :key="index">
					<el-image :src="item.image" fit="contain">
					</el-image>
					<div class="name">{{item.name}}</div>
					<div class="hover">
						<div class="title">
							{{item.name}}
						</div>
						<div class="text">
							{{item.info}}
						</div>
						<i class="el-icon-right"></i>
					</div>
				</div>
			</div>
			<!-- <div class="linkmoer">
				了解更多
			</div> -->
		</div>

		<div class="box">
			<div class="student">
				<div class="main_title">
					<div class="title">学员动态</div>
					<el-image src="./static/images/fgx2.png" fit="contain">
					</el-image>
				</div>
				<div class="user">
					<div class="li" v-for="(item,index) in student" :key="index">
						<el-image :src="item.image" fit="contain">
						</el-image>
						<div class="info">
							<div><span>{{item.name}}</span>{{item.create_time}}</div>
							{{item.content}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins/index'
	import localStorage from '@/utils/localStorage'
	export default {
		mixins: [mixins],
		data() {
			return {
				banner: [],
				teacher:[],
				student:[],
				height: 620,
				about:'',
				info:''
			}
		},
		mounted() {
			this.handindex()
		},
		methods: {
			handindex() {
				this.request({
					url: '/index/guanwang/banner',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.banner = res.data
						}
					}
				})
				this.request({
					url: '/index/guanwang/teacher_list',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.teacher = res.data
						}
					}
				})
				this.request({
					url: '/index/guanwang/student_list',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.student = res.data
						}
					}
				})
				this.request({
					url: '/index/guanwang/about_us',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.about = res.data.info
						}
					}
				})
				this.request({
					url: '/index/guanwang/info',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.info = res.data
						}
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.index_main {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.el-carousel {
		width: 100%;

		img {
			width: 100%;
		}
	}


	.main {
		max-width: 1200px;
		width: 100%;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;

		.infoNum {
			max-width: 1200px;
			width: 100%;
			height: 180px;
			background: #FF6530;
			box-shadow: 0px 5px 10px 0px rgba(204, 204, 204, 0.3);
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: -50px;
			position: relative;
			z-index: 9;

			div {
				width: 33.3%;
				font-size: 16px;
				color: #fff;
				display: flex;
				flex-direction: column;
				align-items: center;

				span {
					font-size: 52px;
					font-weight: bold;
					margin-bottom: 10px;
				}
			}
		}

		.main_title {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 30px 0;

			.title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 42px;
				color: #333;
				font-weight: bold;

			}

			.el-image {
				width: 721px;
				height: 54px;
			}

			.subtitle {
				text-align: center;
				width: 652px;
				font-size: 20px;
				font-weight: 400;
				color: #999999;
			}
		}

		.column_info {
			max-width: 1200px;
			width: 100%;
			min-height: 350px;
			// display: flex;
			// align-items: center;
			// justify-content: space-between;
			// margin-bottom: 50px;
			// margin-top: 60px;

			.left {
				width: 560rpx;
				height: 350px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;

				.title {
					display: flex;
					flex-direction: column;
					font-size: 18px;
					font-weight: bold;
					color: #000000;
					line-height: 30px;

					span {
						font-size: 12px;
						color: #999999;
						line-height: 30px;
					}
				}

				.icon1 {
					width: 36px;
					height: 4px;
					background: #2D82FF;
				}

				.text {
					width: 560px;
					padding-top: 60px;
					height: 250px;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 42px;
				}

				.link {
					width: 114px;
					height: 42px;
					background: #2D82FF;
					font-size: 14px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}

			.right {
				width: 565px;
				height: 350px;
				position: relative;

				.el-image {
					width: 510px;
					height: 295px;
					border-radius: 8px;
					position: absolute;
					z-index: 3;
				}

				.bg {
					width: 478px;
					height: 266px;
					background: #2D82FF;
					border-radius: 8px;
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}
		}

		.teacher {
			max-width: 1200px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 40px 0;

			.li {
				width: 278px;
				height: 366px;
				background: #FFFFFF;
				box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.17);
				display: flex;
				flex-direction: column;
				align-items: center;
				position: relative;

				.el-image {
					width: 278px;
					height: 260px;
				}

				.name {
					width: 278px;
					height: 106px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 25px;
					color: #555555;
				}

				.hover {
					position: absolute;
					top: 13px;
					left: 13px;
					width: 252px;
					height: 234px;
					background: #2D82FF;
					opacity: 0.8;
					display: none;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					color: #fff;

					.title {
						font-size: 25px;
					}

					.text {
						width: 162px;
						height: 29px;
						font-size: 10px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 18px;
						margin: 45px 0;
					}

					i {
						font-size: 18px;
						opacity: 0;
					}
				}
			}

			.li:hover {
				.hover {
					display: flex;
				}
			}
		}

		.linkmoer {
			width: 143px;
			height: 50px;
			background: #2D82FF;
			border-radius: 2px;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			margin: 30px 0;
		}
	}

	.box {
		width: 100%;
		height: 380px;
		background: #2D82FF;
		display: flex;
		align-items: center;
		justify-content: center;

		.student {
			max-width: 1200px;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			.main_title {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 30px 0;

				.title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 42px;
					color: #fff;
					font-weight: bold;

				}

				.el-image {
					width: 721px;
					height: 54px;
					margin-top: 20px;
				}

			}

			.user {
				max-width: 1200px;
				width: 100%;
				margin-top: 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.li {
					width: 380px;
					height: 100px;
					background: #FFFFFF;
					border-radius: 20px;
					display: flex;
					align-items: center;
					padding: 0 30px;

					.el-image {
						width: 58px;
						height: 58px;
						background: #EBEAEA;
						border-radius: 50%;
						margin-right: 20px;
					}

					.info {
						display: flex;
						flex-direction: column;
						font-size: 14px;
						color: #999999;
						line-height: 18px;

						div {
							display: flex;
							color: #9A9A9A;
							align-items: flex-end;
							margin-bottom: 10px;

							span {
								font-size: 18px;
								font-weight: bold;
								color: #000000;
								line-height: 18px;
								margin-right: 16px;
							}
						}
					}
				}
			}
		}

	}
</style>


// WEBPACK FOOTER //
// src/components/index.vue